import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/hit-mouse/2026/Index.vue')
const LotteryRewards = () => import('../activity/hit-mouse/2026/LotteryRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/hit-mouse/2026',
  name: 'activity_hit_mouse_2026',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '打地鼠赢大奖',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/hit-mouse/2026/lottery-rewards',
  name: 'activity_hit_mouse_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '中奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
